'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
export default class TextInput extends Component {
  constructor(...args) {
    super(...args);

    this.onChange = ({
      target: {
        value
      }
    }) => {
      if (value === '') {
        value = null;
      }

      return this.props.onChange(value);
    };
  }

  render() {
    const {
      autoFocus,
      disabled,
      id,
      placeholder,
      readOnly,
      value
    } = this.props;
    return /*#__PURE__*/_jsx(UITextInput, {
      autoFocus: autoFocus,
      disabled: disabled,
      id: id,
      onChange: this.onChange,
      placeholder: placeholder,
      readOnly: readOnly,
      value: value === null ? '' : value
    });
  }

}
TextInput.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};